import axios from '@utils/axios'

const BillAPI = {
  getBill: (billId: number) => axios.get(`/bills/${billId}`),
}

export default BillAPI
